import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Jumbotron, Button, Row, FormControl, Col, ControlLabel } from 'react-bootstrap';
import ReactTelInput from 'react-telephone-input';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';
import { Column, Table } from 'react-virtualized';
import _ from 'lodash';

import CitiesComponent from './CitiesComponent';
import CountriesComponent from './CountriesComponent';
import UserTeams from './UserTeams.js';
import { DistanceBasedCostsForm } from './DistanceBasedCostsForm';
import { gettext } from '../../../i18n/service.js';
import * as settingsActions from '../../../actions/settingsActions';
import * as appActions from '../../../actions/appActions';
import * as fleetActions from '../../../actions/fleetOwnerActions';
import LoopbackHttp from '../../../businessLogic/LoopbackHttp.js';
import * as Validation from '../../../businessLogic/fieldValidation.js';
import DeleteModal from '../../modals/DeleteModal.js';

configureAnchors({ offset: -60, scrollDuration: 200 });

export class DispatcherPlatformComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.editDispatcherPlatform = false;
    this.createDispatcherPlatform = false;
    this.addToDefaultTeam = false;
    this.selectedDispatcherPlatform = undefined;
    this.addedTeams = [];
    this.removedTeams = [];

    _.bindAll(this, ['renderDispatcherPlatformForm', 'resetBools', 'resetState', 'flipCreateDispatcherPlatform',
      'getSelectedDispatcherPlatform', 'renderDispatcherPlatformEditForm', 'getTeams', 'flipEditDispatcherPlatform',
      'validateDispatcherPlatformFields', 'clearCity',
      'createNewDispatcherPlatform', 'updateDispatcherPlatform', 'deleteDispatcherPlatform', 'toggleAddToDefaultTeam', 'setCity', 'setCountry']);

    this.state = {
      name: undefined,
      email: undefined,
      mobile: undefined,
      phone: undefined,
      password: undefined,
      confirmPassword: undefined,
      cityId: undefined,
      countryId: undefined,
      deliveryCommission: undefined,
      expressDeliveryCommission: undefined,
      teamId: undefined,
      filterValue: undefined,
      distanceBasedModifiers: {}
    }

    this.baseState = this.state;
  }

  componentDidMount() {
    this.props.appActions.startSpinner();
    if (LoopbackHttp.isFleet) {
      this.props.settingsActions.getFleetPlatforms(this.props.company.id);
      this.props.settingsActions.getTeamsForFleetSettings(this.props.company.id);
    } else if(LoopbackHttp.isOperator) {
      this.props.settingsActions.getOperatorPlatforms(this.props.account.id);
      this.props.settingsActions.getTeamsForOperatorSettings(this.props.account.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.dispatcherPlatforms !== this.props.dispatcherPlatforms)
      this.props.appActions.endSpinner();

    if(nextProps.dispatcherPlatforms !== this.props.dispatcherPlatforms && this.selectedDispatcherPlatform) {
      let platform = this.selectedDispatcherPlatform
      this.setState(this.selectedDispatcherPlatform);
    }
  }

  teamOperations = () => {
    if(this.addedTeams.length > 0) {
      this.addedTeams.map((team) => {
        console.log(team,
          'dispatcherPlatform',
          this.state.id)
        this.props.fleetActions
          .addToTeam(team,
            'dispatcherPlatform',
            this.state.id);
      })
    }
    if(this.removedTeams.length > 0) {
      this.removedTeams.map((team) => {
        this.props.fleetActions
          .removeFromTeam(team,
            'dispatcherPlatform',
            this.state.id);
      })
    }
  }

  getTeamsAfterEdit = (addedTeams, removedTeams) => {
    this.addedTeams = addedTeams;
    this.removedTeams = removedTeams;
    this.setState({});
  }

  toggleAddToDefaultTeam(e) {
    this.addToDefaultTeam = !this.addToDefaultTeam;
    if (this.addToDefaultTeam)
      this.setState({ teamId: _.find(this.props.teams, {default: true}).id });
    else
      this.setState({ teamId: undefined });
  }

  getTeams() {
    return _.map(this.props.teams, (team) => (
      <option key={`team_${team.id}`} value={team.id}>
        {team.name}
      </option>
    ));
  }

  getSelectedDispatcherPlatform(id) {
    this.resetBools();
    this.props.appActions.startSpinner();
    this.props.settingsActions.getPlatform(id);
    this.selectedDispatcherPlatform = _.find(this.props.dispatcherPlatforms, { 'id': id });
    this.setState(this.selectedDispatcherPlatform);
  }

  flipCreateDispatcherPlatform() {
    this.createDispatcherPlatform = !this.createDispatcherPlatform;
    this.resetState();
  }

  flipEditDispatcherPlatform() {
    this.resetBools();
    this.editDispatcherPlatform = !this.editDispatcherPlatform;
    this.forceUpdate();
    if(this.editDispatcherPlatform && this.selectedDispatcherPlatform)
      this.props.settingsActions.fetchCitiesByCountryId(this.selectedDispatcherPlatform.countryId);
  }

  resetState() {
    this.selectedDispatcherPlatform = undefined;
    for (var prop in this.state) {
      delete this.state[prop];
    }
    this.setState(this.baseState);
  }

  resetBools() {
    this.createDispatcherPlatform = false;
    this.editDispatcherPlatform = false;
  }

  createNewDispatcherPlatform() {
    if (!this.validateDispatcherPlatformFields())
      return false;
    else if (!Validation.passValdationForCreating(this.state.password, this.props.showMessage))
      return false;
    else {
      delete this.state['confirmPassword'];
      delete this.state.filterValue;
      this.state.companyId = this.props.company.id;
      this.props.startSpinner();
      this.props.settingsActions.createPlatform(this.state.teamId, this.state);
      this.resetBools();
      this.resetState();
    }
  }

  updateDispatcherPlatform() {
    if (!this.validateDispatcherPlatformFields()) {
      return false;
    }
    else {
      delete this.state['confirmPassword'];
      delete this.state.filterValue;
      this.props.startSpinner();
      this.teamOperations();
      this.props.settingsActions.updatePlatform(this.state);
      let platformId = this.state.id;
      this.props.fetchCityForInfo(this.state.cityId);
      this.resetBools();
      this.resetState();
      this.getSelectedDispatcherPlatform(platformId);
    }
  }

  clearCity(){
    this.setState({cityId: undefined});
  }

  deleteDispatcherPlatform(id) {
    // this.props.startSpinner();
    this.props.settingsActions.deletePlatform(this.state.id);
    this.resetBools();
    this.resetState();
    this.showDeleteModal = true;
    this.forceUpdate();
  }

  validateDispatcherPlatformFields() {
    return Validation.emailValdation(this.state.email, this.props.showMessage)
      && Validation.nameValidation(this.state.name, this.props.showMessage)
      && Validation.passValdation(this.state.password, this.state.confirmPassword, this.props.showMessage)
      // && Validation.phoneValdation(this.state.phone, this.props.showMessage)
      && Validation.countryValdation(this.state.countryId, this.props.showMessage)
      && Validation.cityValdation(this.state.cityId, this.props.showMessage)
      && (this.editDispatcherPlatform || Validation.teamValdation(this.state.teamId, this.props.showMessage));
  }

  setCity(city) {
    this.setState({ cityId: city.id })
  }

  setCountry(country) {
    this.setState({ countryId: country.id });
    this.props.settingsActions.fetchCitiesByCountryId(country.id);
  }

  renderDispatcherPlatformForm() {
    return (
      <Jumbotron className="position_relative">
        <ScrollableAnchor id={'dispatchers_anchor'}>
          <div />
        </ScrollableAnchor>
        <div className="text_align_center margin_bottom_em">
          <h3>{gettext('PLATFORM-INFO')}</h3>
        </div>
        <Row>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('EMAIL')}</h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.selectedDispatcherPlatform.email}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('NAME')}</h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.selectedDispatcherPlatform.name}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PHONE-NUMBER')}</h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.selectedDispatcherPlatform.phone}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('COUNTRY')}</h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.props.getCountryByCityId(this.selectedDispatcherPlatform.countryId)}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CITY')}</h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.props.getCityById(this.props.cityForInfo)}</h4></label>
              </Col>
            </Row>
          </div>
          <div className="botom_line" />
          <div className="text_align_center margin_bottom_em">
            <h3>{gettext('COST-INFO')}</h3>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('DELIVERY-COST')}</h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.selectedDispatcherPlatform.deliveryCommission}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('EXPRESS-DELIVERY-COST')}</h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.selectedDispatcherPlatform.expressDeliveryCommission}</h4></label>
              </Col>
            </Row>
          </div>
          <div className="botom_line" />
          <DistanceBasedCostsForm
            values={this.selectedDispatcherPlatform.distanceBasedModifiers}>
          </DistanceBasedCostsForm>
          <div className="text_align_center margin_bottom_em">
              <h3>{gettext('TEAMS')}</h3>
            </div>
            <div className="user_data center_div">
              <Row>
                <UserTeams userId={this.selectedDispatcherPlatform.id} userRole={'DispatcherPlatform'}/>
              </Row>
            </div>
        </Row>
        <div className="edit_link">
          <a onClick={() => this.flipEditDispatcherPlatform()}><h4>{gettext('EDIT')}</h4></a>
        </div>
      </Jumbotron>
    );
  }

  renderDispatcherPlatformEditForm() {
    return (
      <Jumbotron className="position_relative">
        <ScrollableAnchor id={'dispatchers_anchor'}>
          <div />
        </ScrollableAnchor>
        <div className="text_align_center margin_bottom_em">
          <h2>{gettext('EDIT-DISPATCHER-PLATFORM')}</h2>
        </div>
        <Row>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('EMAIL')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  defaultValue={this.selectedDispatcherPlatform.email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  placeholder={gettext('EMAIL')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PASSWORD')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="password"
                  required={true}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  placeholder={gettext('PASSWORD')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CONFIRM-PASSWORD')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="password"
                  required={true}
                  onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                  placeholder={gettext('CONFIRM-PASSWORD')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('NAME')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  defaultValue={this.selectedDispatcherPlatform.name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                  placeholder={gettext('NAME')} />
              </Col>
            </Row>

            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PHONE-NUMBER')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <ReactTelInput
                  required={true}
                  defaultCountry="sa"
                  preferredCountries={['sa']}
                  initialValue={"" + this.selectedDispatcherPlatform.phone + ""}
                  flagsImagePath='./flags.png'
                  onChange={(telNumber, selectedCountry) => {
                    this.setState({ phone: parseInt(telNumber.replace(/[^0-9]/g, ''), 10) })
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('COUNTRY')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <CountriesComponent
                  countries={this.props.countries}
                  onSelect={this.setCountry}
                  clearCity={this.clearCity}
                  defaultValue={this.props.getCountryById(this.selectedDispatcherPlatform.countryId)} />
                {/* <FormControl
                  componentClass="select"
                  className="_order_"
                  placeholder="select"
                  onChange={(e) => {
                    this.setState({ countryId: e.target.value });
                    this.props.settingsActions.fetchCitiesByCountryId(e.target.value);
                  }}
                  value={this.state.countryId}
                  name="country">
                  {this.props.getCountries(this.selectedDispatcherPlatform.countryId)}
                </FormControl> */}
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CITY')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <CitiesComponent
                cities={this.props.cities}
                onSelect={this.setCity}
                clearCity={this.clearCity}
                defaultValue={this.props.getCityById(this.props.cityForInfo)} />
              </Col>
            </Row>
          </div>
          <div className="botom_line" />
          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('COST-INFO')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('DELIVERY-COST')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  maxLength={4}
                  defaultValue={this.selectedDispatcherPlatform.deliveryCommission}
                  onChange={(e) => this.setState({ deliveryCommission: e.target.value })}
                  placeholder={gettext('DELIVERY-COST')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('EXPRESS-DELIVERY-COST')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  maxLength={4}
                  defaultValue={this.selectedDispatcherPlatform.expressDeliveryCommission}
                  onChange={(e) => {
                    this.setState({ expressDeliveryCommission: e.target.value });
                  }}
                  placeholder={gettext('EXPRESS-DELIVERY-COST')} />
              </Col>
            </Row>
          </div>

          <div className="botom_line" />


          <DistanceBasedCostsForm
            defaultValues={this.selectedDispatcherPlatform.distanceBasedModifiers}
            isForm={true}
            onChangeCallback={(key, value) => {
              let { distanceBasedModifiers } = this.state;
              if (distanceBasedModifiers === void 0) {
                distanceBasedModifiers = {};
              }
              distanceBasedModifiers[key] = Number(value);
              this.setState({ distanceBasedModifiers: distanceBasedModifiers });
            }}>
          </DistanceBasedCostsForm>
          <div className="text_align_center margin_bottom_em">
              <h3>{gettext('TEAMS')}</h3>
            </div>
            <div className="user_data center_div">
              <Row>
                <UserTeams
                  isEdit
                  getTeamsAfterEdit={this.getTeamsAfterEdit}/>
              </Row>
            </div>

          <div className="botom_line" />
        </Row>
        <div className="actions">
          <Button bsStyle="primary" onClick={() => this.updateDispatcherPlatform()}>{gettext('SAVE')}</Button>
          <Button bsStyle="danger" onClick={() => { this.resetState(); this.flipEditDispatcherPlatform(); }}>{gettext('CANCEL')}</Button>
        </div>
      </Jumbotron>
    );
  }

  renderDispatcherPlatformCreateForm() {
    return (
      <Jumbotron className="position_relative">
        <ScrollableAnchor id={'dispatchers_anchor'}>
          <div />
        </ScrollableAnchor>
        <div className="text_align_center margin_bottom_em">
          <h2>{gettext('NEW-DISPATCHER-PLATFORM')}</h2>
        </div>
        <Row>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('EMAIL')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  placeholder={gettext('EMAIL')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PASSWORD')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="password"
                  required={true}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  placeholder={gettext('PASSWORD')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CONFIRM-PASSWORD')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="password"
                  required={true}
                  onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                  placeholder={gettext('CONFIRM-PASSWORD')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('NAME')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  onChange={(e) => this.setState({ name: e.target.value })}
                  placeholder={gettext('NAME')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PHONE-NUMBER')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <ReactTelInput
                  required={true}
                  defaultCountry="sa"
                  flagsImagePath='./flags.png'
                  preferredCountries={['sa']}
                  onChange={(telNumber, selectedCountry) => {
                    this.setState({ phone: parseInt(telNumber.replace(/[^0-9]/g, ''), 10) })
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('COUNTRY')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <CountriesComponent
                  countries={this.props.countries}
                  onSelect={this.setCountry}
                  clearCity={this.clearCity} />
                {/* <FormControl
                  componentClass="select"
                  className="_order_"
                  placeholder="select"
                  onChange={(e) => {
                    this.setState({ countryId: e.target.value });
                    this.props.settingsActions.fetchCitiesByCountryId(e.target.value);
                  }}
                  name="country">
                  <option disabled selected value={undefined}>{gettext('SELECT-COUNTRY')}</option>
                  {this.props.getCountries()}
                </FormControl> */}
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CITY')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <CitiesComponent
                cities={this.props.cities}
                onSelect={this.setCity}
                clearCity={this.clearCity} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('TEAM')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  componentClass="select"
                  className="_order_"
                  placeholder="select"
                  disabled={this.addToDefaultTeam}
                  onChange={(e) => this.setState({ teamId: e.target.value })}
                  name="city">
                  <option disabled selected value={undefined}>{gettext('SELECT-TEAM')}</option>
                  {this.getTeams()}
                </FormControl>
                <div className="checkbox">
                  <label>
                    <input type="checkbox"
                      checked={this.addToDefaultTeam}
                      onChange={(e) => this.toggleAddToDefaultTeam(e)} />
                    {gettext('ADD-TO-DEFAULT-TEAM')}
                    {this.addToDefaultTeam ? ' - ' + _.find(this.props.teams, {default: true}).name : ''}
                  </label>
                </div>
              </Col>
            </Row>
          </div>
          <div className="botom_line" />
          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('COST-INFO')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('DELIVERY-COST')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  required={true}
                  maxLength={4}
                  onChange={(e) => this.setState({ deliveryCommission: e.target.value })}
                  placeholder={gettext('DELIVERY-COST')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('EXPRESS-DELIVERY-COST')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  maxLength={4}
                  onChange={(e) => this.setState({ expressDeliveryCommission: e.target.value })}
                  placeholder={gettext('EXPRESS-DELIVERY-COST')} />
              </Col>
            </Row>
          </div>

          <div className="botom_line" />
          <DistanceBasedCostsForm
            defaultValues={null}
            isForm={true}
            onChangeCallback={(key, value) => {
              let { distanceBasedModifiers } = this.state;
              if (distanceBasedModifiers === void 0) {
                distanceBasedModifiers = {};
              }
              distanceBasedModifiers[key] = Number(value);
              this.setState({ distanceBasedModifiers: distanceBasedModifiers });
            }}>
          </DistanceBasedCostsForm>
        </Row>
        <div className="actions">
          <Button bsStyle="primary" onClick={() => this.createNewDispatcherPlatform()}>{gettext('SAVE')}</Button>
          <Button bsStyle="danger" onClick={() => { this.resetState(); this.flipEditDispatcherPlatform(); }}>{gettext('CANCEL')}</Button>
        </div>
      </Jumbotron>
    );
  }

  deleteCallback = () => {
    this.resetBools();
    this.resetState();
  }



  render() {
    let dispatcherPlatforms = _.uniqBy(this.props.dispatcherPlatforms, 'id');

    dispatcherPlatforms = _.filter(dispatcherPlatforms, (dispatcher) => {
      return this.state.filterValue
        ? dispatcher.name.toUpperCase().indexOf(this.state.filterValue.toUpperCase()) != -1
        || dispatcher.email.toUpperCase().indexOf(this.state.filterValue.toUpperCase()) != -1
        || (dispatcher.shopName && dispatcher.shopName.toUpperCase().indexOf(this.state.filterValue.toUpperCase()) != -1)
        : true;
    });

    // dispatcherPlatforms = _.map(dispatcherPlatforms, (dispatcher) => {
    //   const isDispatcherSelected = this.selectedDispatcherPlatform && dispatcher.id === this.selectedDispatcherPlatform.id;
    //   const className = isDispatcherSelected ? 'active' : '';

    //   return (
    //     <Tr className={className} key={dispatcher.id} onClick={(e) => this.getSelectedDispatcherPlatform(dispatcher.id)}>
    //       <Td column={gettext('NAME')}>
    //         {dispatcher.name}
    //       </Td>
    //       <Td column={gettext('EMAIL')}>
    //         {dispatcher.email}
    //       </Td>
    //     </Tr>
    //   );
    // });

    return (
      <div className="dispatcher_profile">
        <Jumbotron>
          <div className="item_head_title">
            <h3>{gettext('DISPATCHER-PLATFORMS')}</h3>
          </div>
          <Row className="center_flex margin_bottom_em">
            <Col sm={10}>
              <Col sm={12}>
                <FormControl
                  type="text"
                  required={true}
                  placeholder={gettext('SEARCH')}
                  onChange={(e) => this.setState({ filterValue: e.target.value })} />
              </Col>
            </Col>
          </Row>
          <Row className="center_flex">
            <Col sm={10}>
              <Col sm={12}>
                <div className="table_container">
                  <Table
                    width={300}
                    height={300}
                    headerHeight={20}
                    rowHeight={30}
                    rowClassName={({ index }) =>
                      this.selectedDispatcherPlatform
                      && dispatcherPlatforms[index] === this.selectedDispatcherPlatform ? 'active' : ''
                    }
                    rowCount={dispatcherPlatforms.length}
                    rowGetter={({ index }) => dispatcherPlatforms[index]}
                    onRowClick={(e) => {
                      this.getSelectedDispatcherPlatform(e.rowData.id);
                    }}
                    >
                    <Column
                      label='Name'
                      dataKey='name'
                      width={500}
                    />
                    <Column
                      width={500}
                      label='Email'
                      dataKey='email'
                    />
                </Table>
                </div>
                <div className="milti_controls">
                  <Button className="multi_btn margin_bottom_halfem" onClick={() => { this.flipCreateDispatcherPlatform() }}>+</Button>
                  {
                     this.selectedDispatcherPlatform &&
                     <DeleteModal
                      delete={this.deleteDispatcherPlatform}
                      id={this.state.id}
                      callBack={this.deleteCallback}
                      text={`${gettext('DELETE-PLATFORM-CONFIRMATION')}`}
                      buttonClass={'multi_btn margin_bottom_halfem'}
                      buttonText={'-'}/>
                   }
                </div>
              </Col>
            </Col>
          </Row>
        </Jumbotron>
        {
          this.createDispatcherPlatform ? this.renderDispatcherPlatformCreateForm() : ''
        }
        {
          this.selectedDispatcherPlatform
            ? this.editDispatcherPlatform ? this.renderDispatcherPlatformEditForm() : this.renderDispatcherPlatformForm()
            : ''
        }

      </div>
    );
  }
}

DispatcherPlatformComponent.propTypes = {
};

function mapStateToProps(state) {
  return {
    dispatcherPlatforms: state.settingsPageReducer.dispatcherPlatforms,
    company: state.appReducer.company,
    account: state.appReducer.account,
    teams: state.settingsPageReducer.teams,
    userTeams: state.settingsPageReducer.userTeams,
    cities: state.settingsPageReducer.cities
  };
}

function mapDispatchToProps(dispatch) {
  return {
    settingsActions: bindActionCreators(settingsActions, dispatch),
    appActions:  bindActionCreators(appActions, dispatch),
    fleetActions:  bindActionCreators(fleetActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DispatcherPlatformComponent);



// WEBPACK FOOTER //
// ./src/components/settings/components/DispatcherPlatformComponent.js